import React from "react";

const ProductLogo = ({
  productLogo,
  productLogoAltText,
  onClick,
  productClassName = "object-center ml-[6px] md:ml-4 md:h-[57px] h-[32px] w-[64px] max-w-[64px] md:w-[102px] md:max-w-[102px] cursor-pointer bg-white rounded-[4px]",
  productImageClassName = "object-contain h-full",
}) => {
  if (!productLogo) return null;

  return (
    <div className={`${productClassName} md:py-[6px] py-[3px] px-[3px] md:px-[6px] flex items-center justify-center`} onClick={onClick}>
      <img className={productImageClassName} src={productLogo} alt={productLogoAltText} />
    </div>
  );
};

export default ProductLogo;
